export const diningOutData = [
    {
        "type": "restaurant",
        "info": {
            "resId": 18926279,
            "name": "Udupi Shrikrishna Veg Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/9/18926279/48b359af90c2601c9a0572cc2224997e_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/9/18926279/48b359af90c2601c9a0572cc2224997e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/9/18926279/01cd455a034207a3cdf8ba4a7cc1732c_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.2",
                "rating_text": "4.2",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "24.6K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.2",
                        "reviewCount": "324",
                        "reviewTextSmall": "324 Reviews",
                        "subtext": "324 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.2",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.2",
                        "reviewCount": "24.3K",
                        "reviewTextSmall": "24.3K Reviews",
                        "subtext": "24.3K Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.2",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.8"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹300 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "Gadia Vihar, Aurangabad",
                "address": "Plot 34, Shop 1, Deva Nagari, Gadia Vihar, Aurangabad",
                "localityUrl": "aurangabad/gadia-vihar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/south-indian/",
                    "name": "South Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹300 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/udupi-shrikrishna-veg-restaurant-gadia-vihar/info",
            "clickActionDeeplink": ""
        },
        "distance": "3.9 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18926279\",\"element_type\":\"listing\",\"rank\":46}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19539100,
            "name": "No.1  Vada Pav Kolhapur",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/19539100/70269637a3984893dab96f517c576304_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/19539100/70269637a3984893dab96f517c576304_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": false
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.3",
                "rating_text": "3.3",
                "rating_subtitle": "Average",
                "rating_color": "CDD614",
                "votes": "4",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.3",
                        "reviewCount": "4",
                        "reviewTextSmall": "4 Reviews",
                        "subtext": "4 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.3",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "0",
                        "reviewTextSmall": "0 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹100 for two"
            },
            "cfo": {
                "text": "₹40 for one"
            },
            "locality": {
                "name": "Nirala Bazar, Aurangabad",
                "address": "Plot 223, Samarth Nagar, Near Vivekanand College, Nirala Bazar, Aurangabad",
                "localityUrl": "aurangabad/nirala-bazar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹100 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/no-1-vada-pav-kolhapur-nirala-bazar/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.2 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19539100\",\"element_type\":\"listing\",\"rank\":47}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19733580,
            "name": "No Meat Naan",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/19733580/1d517df2f6934ac711602c3d66f10b94_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/19733580/1d517df2f6934ac711602c3d66f10b94_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/19733580/8bab5bd6773ca6cfbc9101f96f0a7949_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.2",
                "rating_text": "4.2",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "1,889",
                "subtext": "REVIEW",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.9",
                        "reviewCount": "20",
                        "reviewTextSmall": "20 Reviews",
                        "subtext": "20 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.9",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.5",
                        "reviewCount": "1,869",
                        "reviewTextSmall": "1,869 Reviews",
                        "subtext": "1,869 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.5",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.5"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹500 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "CIDCO, Aurangabad",
                "address": "Shop 09, Tulsi Arcade, Cannought Place, CIDCO, Aurangabad",
                "localityUrl": "aurangabad/cidco-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/bakery/",
                    "name": "Bakery"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹500 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/no-meat-naan-1-cidco/info",
            "clickActionDeeplink": ""
        },
        "distance": "124 m",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19733580\",\"element_type\":\"listing\",\"rank\":48}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500055,
            "name": "Smile Veg Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/5/2500055/bf4b449d8fe3d320ce162a2a3ba0c5b9_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/5/2500055/bf4b449d8fe3d320ce162a2a3ba0c5b9_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/5/2500055/8b7f7ce45e60156371ce25aa76e98d6a_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.2",
                "rating_text": "4.2",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "18.7K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.0",
                        "reviewCount": "566",
                        "reviewTextSmall": "566 Reviews",
                        "subtext": "566 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.0",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.4",
                        "reviewCount": "18.1K",
                        "reviewTextSmall": "18.1K Reviews",
                        "subtext": "18.1K Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.4",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.4"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹400 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Nirala Bazar, Aurangabad",
                "address": "13-14, Samarth Nagar, MP Law College Campus, Nirala Bazar, Aurangabad",
                "localityUrl": "aurangabad/nirala-bazar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/south-indian/",
                    "name": "South Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sandwich/",
                    "name": "Sandwich"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹400 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/smile-veg-restaurant-nirala-bazar/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.1 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500055\",\"element_type\":\"listing\",\"rank\":49}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500021,
            "name": "Swad Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/1/2500021/35f5b78b6d0f1030beb91565428b263a_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/1/2500021/35f5b78b6d0f1030beb91565428b263a_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/1/2500021/a05f6fbaf08bd5626248047fb3c7db00_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "1,993",
                "subtext": "REVIEW",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.9",
                        "reviewCount": "179",
                        "reviewTextSmall": "179 Reviews",
                        "subtext": "179 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.9",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.3",
                        "reviewCount": "1,814",
                        "reviewTextSmall": "1,814 Reviews",
                        "subtext": "1,814 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.3",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹200 for two"
            },
            "cfo": {
                "text": "₹100 for one"
            },
            "locality": {
                "name": "Usmanpura, Aurangabad",
                "address": "Kanchan Chambers, Station Road, Near Kranti Chowk, Usmanpura, Aurangabad",
                "localityUrl": "aurangabad/usmanpura-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                    "name": "Maharashtrian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDhcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/gujarati/",
                    "name": "Gujarati"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODhcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/rajasthani/",
                    "name": "Rajasthani"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹200 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/swad-restaurant-usmanpura/info",
            "clickActionDeeplink": ""
        },
        "distance": "3.8 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500021\",\"element_type\":\"listing\",\"rank\":50}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500242,
            "name": "Madhuban Garden Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/2/2500242/bbb27767668121c3cd065ba42fffdc45_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/2/2500242/bbb27767668121c3cd065ba42fffdc45_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/2/2500242/e557e4073597ae4345e78beb72ea7bac_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.1",
                "rating_text": "4.1",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "72",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.1",
                        "reviewCount": "60",
                        "reviewTextSmall": "60 Reviews",
                        "subtext": "60 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.1",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "12",
                        "reviewTextSmall": "12 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹800 for two"
            },
            "cfo": {
                "text": "₹350 for one"
            },
            "locality": {
                "name": "Gadia Vihar, Aurangabad",
                "address": "Beed Bypass, Gadia Vihar, Aurangabad",
                "localityUrl": "aurangabad/gadia-vihar-restaurants"
            },
            "timing": {
                "text": "Opens in 15 minutes",
                "color": "#e5521f"
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjMzXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/ice-cream/",
                    "name": "Ice Cream"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTI4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sichuan/",
                    "name": "Sichuan"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹800 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/madhuban-garden-restaurant-gadia-vihar/info",
            "clickActionDeeplink": ""
        },
        "distance": "3 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500242\",\"element_type\":\"listing\",\"rank\":51}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20582111,
            "name": "Chandramukhi Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/1/20582111/cf4fe2536bac1c7d50634a15657cc23f_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/1/20582111/cf4fe2536bac1c7d50634a15657cc23f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/1/20582111/5dcdeedf43905b7ba7e3a0b2a6a0cf36_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.4",
                "rating_text": "3.4",
                "rating_subtitle": "Average",
                "rating_color": "CDD614",
                "votes": "8",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.4",
                        "reviewCount": "5",
                        "reviewTextSmall": "5 Reviews",
                        "subtext": "5 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.4",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "3",
                        "reviewTextSmall": "3 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹600 for two"
            },
            "cfo": {
                "text": "₹250 for one"
            },
            "locality": {
                "name": "Gadia Vihar, Aurangabad",
                "address": "Plot 28/A, Gate 93, Deolai Aurangabad, Deolai Road, Opposite Medi Health Hospital, Gadia Vihar, Aurangabad",
                "localityUrl": "aurangabad/gadia-vihar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹600 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/chandramukhi-restaurant-gadia-vihar/info",
            "clickActionDeeplink": ""
        },
        "distance": "3.9 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20582111\",\"element_type\":\"listing\",\"rank\":52}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19989584,
            "name": "The Belgian Waffle Co.",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/8/19334338/2255d12106845f7d1b5f065be13215d4_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/8/19334338/2255d12106845f7d1b5f065be13215d4_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/4/19989584/bc2303bd64480b09a48a569b23722f32_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.9",
                "rating_text": "3.9",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "1,381",
                "subtext": "REVIEW",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.4",
                        "reviewCount": "5",
                        "reviewTextSmall": "5 Reviews",
                        "subtext": "5 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.4",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.5",
                        "reviewCount": "1,376",
                        "reviewTextSmall": "1,376 Reviews",
                        "subtext": "1,376 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.5",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "800"
                                    },
                                    "rating": "4.5"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.4"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹350 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "Nirala Bazar, Aurangabad",
                "address": "Shop 110, Tapdia Circle, Samarth Nagar, Nirala Bazar, Aurangabad",
                "localityUrl": "aurangabad/nirala-bazar-restaurants"
            },
            "timing": {
                "text": "Opens in 15 minutes",
                "color": "#e5521f"
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2N1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/waffle/",
                    "name": "Waffle"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2OFwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/pancake/",
                    "name": "Pancake"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NlwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/shake/",
                    "name": "Shake"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹350 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/the-belgian-waffle-co-nirala-bazar/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.1 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19989584\",\"element_type\":\"listing\",\"rank\":53}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500001,
            "name": "The Society - Ambassador Ajanta",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/1/2500001/e3fcbc07866f1e4e023263b9c9124129_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/1/2500001/e3fcbc07866f1e4e023263b9c9124129_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/1/2500001/4e5564bf79fe34edcaee5997a911606c_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.9",
                "rating_text": "3.9",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "22",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.9",
                        "reviewCount": "22",
                        "reviewTextSmall": "22 Reviews",
                        "subtext": "22 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.9",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "0",
                        "reviewTextSmall": "0 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,500 for two"
            },
            "cfo": {
                "text": "₹600 for one"
            },
            "locality": {
                "name": "Ambassador Ajanta, CIDCO, Aurangabad",
                "address": "R4A, MIDC, Chikalthana, Opposite Highcourt, CIDCO, Aurangabad",
                "localityUrl": "aurangabad/restaurants/in/ambass"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/italian/",
                    "name": "Italian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/american/",
                    "name": "American"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                    "name": "Maharashtrian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,500 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/the-society-ambassador-ajanta-cidco/info",
            "clickActionDeeplink": ""
        },
        "distance": "222 m",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500001\",\"element_type\":\"listing\",\"rank\":54}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 21175103,
            "name": "Karim's Original From Delhi 6",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/3/21175103/84b9d26c21a2d15ee2ad535e52e34a45_o2_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/21175103/84b9d26c21a2d15ee2ad535e52e34a45_o2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/3/21175103/84b9d26c21a2d15ee2ad535e52e34a45_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "50",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "",
                        "reviewCount": "2",
                        "reviewTextSmall": "2 Reviews",
                        "subtext": "Does not offer Dining",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.1",
                        "reviewCount": "48",
                        "reviewTextSmall": "48 Reviews",
                        "subtext": "48 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.1",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,000 for two"
            },
            "cfo": {
                "text": "₹400 for one"
            },
            "locality": {
                "name": "Nirala Bazar, Aurangabad",
                "address": "CTS 2588, House 5-2-71, Jubli Park, Kotwalpura, Nirala Bazar, Aurangabad",
                "localityUrl": "aurangabad/nirala-bazar-restaurants"
            },
            "timing": {
                "text": "Opens at 1pm",
                "color": "#ab000d"
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/mughlai/",
                    "name": "Mughlai"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/rolls/",
                    "name": "Rolls"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,000 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/karims-original-from-delhi-6-nirala-bazar/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.8 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21175103\",\"element_type\":\"listing\",\"rank\":55}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 18904582,
            "name": "Kareem's Kebab & Biryani",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/2/18904582/373b5ea7049951beecb32195d998bc52_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/2/18904582/373b5ea7049951beecb32195d998bc52_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/2/18904582/2a88652a479773822ce96380a2f3099a_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "7,996",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.1",
                        "reviewCount": "147",
                        "reviewTextSmall": "147 Reviews",
                        "subtext": "147 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.1",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.1",
                        "reviewCount": "7,849",
                        "reviewTextSmall": "7,849 Reviews",
                        "subtext": "7,849 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.1",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.6"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹650 for two"
            },
            "cfo": {
                "text": "₹300 for one"
            },
            "locality": {
                "name": "Prozone Mall, Chicalthana, Aurangabad",
                "address": "5-6, 1st Floor, Prozone Mall, Chikalthana, Aurangabad",
                "localityUrl": "aurangabad/restaurants/in/prozone-mall-chicalthana"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/rolls/",
                    "name": "Rolls"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹650 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/kareems-kebab-biryani-chikalthana/info",
            "clickActionDeeplink": ""
        },
        "distance": "1 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18904582\",\"element_type\":\"listing\",\"rank\":56}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 21191660,
            "name": "Khoraaki",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/21191660/e8f7668988c85a3589c23f0670df13b4_o2_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/21191660/e8f7668988c85a3589c23f0670df13b4_o2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/21191660/e8f7668988c85a3589c23f0670df13b4_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.1",
                "rating_text": "4.1",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "75",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "",
                        "reviewCount": "2",
                        "reviewTextSmall": "2 Reviews",
                        "subtext": "Does not offer Dining",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.2",
                        "reviewCount": "73",
                        "reviewTextSmall": "73 Reviews",
                        "subtext": "73 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.2",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹450 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Delhi Gate Area, Aurangabad",
                "address": "Aftab Plaza, Near Barbarian Power Gym, Docter Rafiq Zakaria Road, Delhi Gate Area, Aurangabad",
                "localityUrl": "aurangabad/delhi-gate-area-restaurants"
            },
            "timing": {
                "text": "Opens at 2pm",
                "color": "#ab000d"
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/pizza/",
                    "name": "Pizza"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/burger/",
                    "name": "Burger"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sandwich/",
                    "name": "Sandwich"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sea-food/",
                    "name": "Seafood"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/salad/",
                    "name": "Salad"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹450 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/khoraaki-delhi-gate-area/info",
            "clickActionDeeplink": ""
        },
        "distance": "3.4 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21191660\",\"element_type\":\"listing\",\"rank\":57}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
        {
            "type": "restaurant",
            "info": {
                "resId": 19761636,
                "name": "Shree Sandwich",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/6/19761636/8cb5341c5582d785426261dc0e42c786_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/6/19761636/8cb5341c5582d785426261dc0e42c786_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/6/19761636/a6b2766d1d1ca41f96bdfc1ba3d35baa_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.7",
                    "rating_text": "3.7",
                    "rating_subtitle": "Good",
                    "rating_color": "9ACD32",
                    "votes": "575",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.3",
                            "reviewCount": "4",
                            "reviewTextSmall": "4 Reviews",
                            "subtext": "4 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.3",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "500"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.2",
                            "reviewCount": "571",
                            "reviewTextSmall": "571 Reviews",
                            "subtext": "571 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.2",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.2"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.8"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.6"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹150 for two"
                },
                "cfo": {
                    "text": "₹100 for one"
                },
                "locality": {
                    "name": "CIDCO, Aurangabad",
                    "address": "Plot 1190, Sai Nagar, Near Raju Gandhi Stadium, CIDCO, Aurangabad",
                    "localityUrl": "aurangabad/cidco-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/sandwich/",
                        "name": "Sandwich"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                        "name": "Street Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹150 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/shree-sandwich-cidco/info",
                "clickActionDeeplink": ""
            },
            "distance": "730 m",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19761636\",\"element_type\":\"listing\",\"rank\":58}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500990,
                "name": "Hotel Modak Pure Veg Restaurant",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/0/2500990/2abde7a39b74aa442b80cf8ef2053e07_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/2500990/2abde7a39b74aa442b80cf8ef2053e07_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/0/2500990/d94f03ddf6cfe7fa36913d8cc982ce8c_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.2",
                    "rating_text": "4.2",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "134",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.0",
                            "reviewCount": "75",
                            "reviewTextSmall": "75 Reviews",
                            "subtext": "75 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.0",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.4",
                            "reviewCount": "59",
                            "reviewTextSmall": "59 Reviews",
                            "subtext": "59 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.4",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.4"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.1"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹600 for two"
                },
                "cfo": {
                    "text": "₹250 for one"
                },
                "locality": {
                    "name": "Mukundwadi, Aurangabad",
                    "address": "Shivaji Chowk, Jay Bhavani Nagar, Mukundwadi, Aurangabad",
                    "localityUrl": "aurangabad/mukundwadi-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/south-indian/",
                        "name": "South Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/kebab/",
                        "name": "Kebab"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹600 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/hotel-modak-pure-veg-restaurant-mukundwadi/info",
                "clickActionDeeplink": ""
            },
            "distance": "1.3 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500990\",\"element_type\":\"listing\",\"rank\":59}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500097,
                "name": "Harry's Bar - The Aures Hotel",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/7/2500097/7cfcf3c7c12d861c92ee04f3f8213336_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/7/2500097/7cfcf3c7c12d861c92ee04f3f8213336_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": false
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.4",
                    "rating_text": "4.4",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "90",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "4.4",
                            "reviewCount": "90",
                            "reviewTextSmall": "90 Reviews",
                            "subtext": "90 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "4.4",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "0",
                            "reviewTextSmall": "0 Reviews",
                            "subtext": "Not enough Delivery Reviews",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "grey",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹1,500 for two"
                },
                "cfo": {
                    "text": "₹600 for one"
                },
                "locality": {
                    "name": "Hotel Keys The Aures, Vedant Nagar, Aurangabad",
                    "address": "Hotel Keys The Aures, Kranti Chowk, Usmanpura, Aurangabad",
                    "localityUrl": "aurangabad/restaurants/in/hotel-keys-the-aures-vedant-nagar"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/bar-food/",
                        "name": "Bar Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                        "name": "North Indian"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,500 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/harrys-bar-the-aures-hotel-usmanpura/info",
                "clickActionDeeplink": ""
            },
            "distance": "4.6 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500097\",\"element_type\":\"listing\",\"rank\":60}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 19680011,
                "name": "The Ghost Kitchen",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/1/19680011/64fb60994413e2a5580e0508b7621c2e_o2_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/1/19680011/64fb60994413e2a5580e0508b7621c2e_o2_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/1/19680011/64fb60994413e2a5580e0508b7621c2e_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.0",
                    "rating_text": "4.0",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "815",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.9",
                            "reviewCount": "56",
                            "reviewTextSmall": "56 Reviews",
                            "subtext": "56 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.9",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.1",
                            "reviewCount": "759",
                            "reviewTextSmall": "759 Reviews",
                            "subtext": "759 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.1",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.1"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.9"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.7"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹400 for two"
                },
                "cfo": {
                    "text": "₹200 for one"
                },
                "locality": {
                    "name": "CIDCO, Aurangabad",
                    "address": "Plot 3/13, Tirupati Housing Society, CIDCO, Aurangabad",
                    "localityUrl": "aurangabad/cidco-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹400 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/the-ghost-kitchen-cidco/info",
                "clickActionDeeplink": ""
            },
            "distance": "205 m",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19680011\",\"element_type\":\"listing\",\"rank\":61}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20133043,
                "name": "Nature Valley",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/20133043/c120ac5da4608949143b44d4361cef18_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/3/20133043/c120ac5da4608949143b44d4361cef18_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/3/20133043/b65cc0d86d8b8f8f26197b9a4e70a35e_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.9",
                    "rating_text": "3.9",
                    "rating_subtitle": "Good",
                    "rating_color": "9ACD32",
                    "votes": "7",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.9",
                            "reviewCount": "4",
                            "reviewTextSmall": "4 Reviews",
                            "subtext": "4 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.9",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "3",
                            "reviewTextSmall": "3 Reviews",
                            "subtext": "Not enough Delivery Reviews",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "grey",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹400 for two"
                },
                "cfo": {
                    "text": "₹200 for one"
                },
                "locality": {
                    "name": "Nirala Bazar, Aurangabad",
                    "address": "B-7, CTS 20592-29, Chandrakala Samarth Nagar, Zone D, Nirala Bazar, Aurangabad",
                    "localityUrl": "aurangabad/nirala-bazar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹400 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/nature-valley-nirala-bazar/info",
                "clickActionDeeplink": ""
            },
            "distance": "4 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20133043\",\"element_type\":\"listing\",\"rank\":62}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500367,
                "name": "MH20",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/7/2500367/30ebdef0f14d4cb2ed293cb93f5f0600_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/7/2500367/30ebdef0f14d4cb2ed293cb93f5f0600_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/7/2500367/ac260eea8999a94635ad37307ef3208b_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.7",
                    "rating_text": "3.7",
                    "rating_subtitle": "Good",
                    "rating_color": "9ACD32",
                    "votes": "124",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.6",
                            "reviewCount": "95",
                            "reviewTextSmall": "95 Reviews",
                            "subtext": "95 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.6",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "3.8",
                            "reviewCount": "29",
                            "reviewTextSmall": "29 Reviews",
                            "subtext": "29 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "3.8",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.8"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹1,100 for two"
                },
                "cfo": {
                    "text": "₹450 for one"
                },
                "locality": {
                    "name": "Gadia Vihar, Aurangabad",
                    "address": "22, Shanoorwadi, Near Beed Bypass, Gadia Vihar, Aurangabad",
                    "localityUrl": "aurangabad/gadia-vihar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/mughlai/",
                        "name": "Mughlai"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                        "name": "Biryani"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/sea-food/",
                        "name": "Seafood"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                        "name": "Maharashtrian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹1,100 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/mh20-gadia-vihar/info",
                "clickActionDeeplink": ""
            },
            "distance": "4.2 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500367\",\"element_type\":\"listing\",\"rank\":63}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500164,
                "name": "Koyla Dum Biryanis & Kebabs",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/4/2500164/053d8c4a9fbc14ec2da9ed2c05f6a556_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/4/2500164/053d8c4a9fbc14ec2da9ed2c05f6a556_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/4/2500164/75d92311d93808ad5a8f77210670750b_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.9",
                    "rating_text": "3.9",
                    "rating_subtitle": "Good",
                    "rating_color": "9ACD32",
                    "votes": "6,755",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.8",
                            "reviewCount": "617",
                            "reviewTextSmall": "617 Reviews",
                            "subtext": "617 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.8",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.1",
                            "reviewCount": "6,138",
                            "reviewTextSmall": "6,138 Reviews",
                            "subtext": "6,138 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.1",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.1"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.9"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.8"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹400 for two"
                },
                "cfo": {
                    "text": "₹200 for one"
                },
                "locality": {
                    "name": "CIDCO, Aurangabad",
                    "address": "Shop 12, Near Connaught Garden, Gate 1, CIDCO, Aurangabad",
                    "localityUrl": "aurangabad/cidco-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                        "name": "Biryani"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/mughlai/",
                        "name": "Mughlai"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹400 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/koyla-dum-biryanis-kebabs-1-cidco/info",
                "clickActionDeeplink": ""
            },
            "distance": "77 m",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500164\",\"element_type\":\"listing\",\"rank\":64}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 19522709,
                "name": "Rock N Roll",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/19522709/eac5354c1ca5b1dbeef49817466a926f_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/19522709/eac5354c1ca5b1dbeef49817466a926f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/19522709/403a3bf665d424b068e3d0eb45ed125e_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.4",
                    "rating_text": "3.4",
                    "rating_subtitle": "Average",
                    "rating_color": "CDD614",
                    "votes": "3,558",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "2.7",
                            "reviewCount": "16",
                            "reviewTextSmall": "16 Reviews",
                            "subtext": "16 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "2.7",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "yellow",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.1",
                            "reviewCount": "3,542",
                            "reviewTextSmall": "3,542 Reviews",
                            "subtext": "3,542 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.1",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.1"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.9"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.8"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹200 for two"
                },
                "cfo": {
                    "text": "₹100 for one"
                },
                "locality": {
                    "name": "CIDCO, Aurangabad",
                    "address": "Shop 15, Plot 10/B1, Ajanta Complex, CIDCO, Aurangabad",
                    "localityUrl": "aurangabad/cidco-restaurants"
                },
                "timing": {
                    "text": "Opens at 1pm",
                    "color": "#ab000d"
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/rolls/",
                        "name": "Rolls"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹200 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/rock-n-roll-cidco/info",
                "clickActionDeeplink": ""
            },
            "distance": "169 m",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19522709\",\"element_type\":\"listing\",\"rank\":65}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 20732427,
                "name": "Starbucks Coffee",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/7/20732427/ce3d9ecf373d6e69fa05857430f4f455_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/7/20732427/ce3d9ecf373d6e69fa05857430f4f455_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/7/20732427/8747ef5ce5514b040fe3ae16cc92dc98_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.2",
                    "rating_text": "4.2",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "738",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "",
                            "reviewCount": "2",
                            "reviewTextSmall": "2 Reviews",
                            "subtext": "Does not offer Dining",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.3",
                            "reviewCount": "736",
                            "reviewTextSmall": "736 Reviews",
                            "subtext": "736 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.3",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.3"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.2"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "4.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹900 for two"
                },
                "cfo": {
                    "text": "₹400 for one"
                },
                "locality": {
                    "name": "CIDCO, Aurangabad",
                    "address": "BiZZ Zone, Cannought Place, CIDCO, Aurangabad",
                    "localityUrl": "aurangabad/cidco-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/cafes/",
                        "name": "Cafe"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹900 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/starbucks-coffee-cidco/info",
                "clickActionDeeplink": ""
            },
            "distance": "84 m",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20732427\",\"element_type\":\"listing\",\"rank\":66}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500135,
                "name": "Domino's Pizza",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/chains/9/2500019/2dc1f598b7cc18df67a5c043f6109a6e_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/9/2500019/2dc1f598b7cc18df67a5c043f6109a6e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/5/2500135/d03d6c5aaad993dd803ca77de48d4bc2_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "4.0",
                    "rating_text": "4.0",
                    "rating_subtitle": "Very Good",
                    "rating_color": "5BA829",
                    "votes": "5,731",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.9",
                            "reviewCount": "630",
                            "reviewTextSmall": "630 Reviews",
                            "subtext": "630 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.9",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "4.1",
                            "reviewCount": "5,101",
                            "reviewTextSmall": "5,101 Reviews",
                            "subtext": "5,101 Delivery Reviews",
                            "color": "#E23744",
                            "ratingV2": "4.1",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "700"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "700"
                                        },
                                        "rating": "4.1"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "600"
                                        },
                                        "rating": "3.9"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "green",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹400 for two"
                },
                "cfo": {
                    "text": "₹200 for one"
                },
                "locality": {
                    "name": "Nirala Bazar, Aurangabad",
                    "address": "Tapadia Plaza, Tapadia Circle, Maljipura, New Samarth Nagar, Nirala Bazar, Aurangabad",
                    "localityUrl": "aurangabad/nirala-bazar-restaurants"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/pizza/",
                        "name": "Pizza"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/italian/",
                        "name": "Italian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/pasta/",
                        "name": "Pasta"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                        "name": "Fast Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                        "name": "Desserts"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹400 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/dominos-pizza-nirala-bazar/info",
                "clickActionDeeplink": ""
            },
            "distance": "4.1 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500135\",\"element_type\":\"listing\",\"rank\":67}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        {
            "type": "restaurant",
            "info": {
                "resId": 2500129,
                "name": "Hotel Amarpreet",
                "image": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/2500129/ae310506ac19b76624d6bc91b830a389_featured_v2.jpg",
                    "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/2500129/ae310506ac19b76624d6bc91b830a389_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
                },
                "o2FeaturedImage": {
                    "url": "https://b.zmtcdn.com/data/pictures/9/2500129/734f3111bbe17f67b7e6887d87ebca9e_o2_featured_v2.jpg"
                },
                "rating": {
                    "has_fake_reviews": 0,
                    "aggregate_rating": "3.5",
                    "rating_text": "3.5",
                    "rating_subtitle": "Good",
                    "rating_color": "9ACD32",
                    "votes": "45",
                    "subtext": "REVIEWS",
                    "is_new": false
                },
                "ratingNew": {
                    "newlyOpenedObj": null,
                    "suspiciousReviewObj": null,
                    "ratings": {
                        "DINING": {
                            "rating_type": "DINING",
                            "rating": "3.5",
                            "reviewCount": "35",
                            "reviewTextSmall": "35 Reviews",
                            "subtext": "35 Dining Reviews",
                            "color": "#1C1C1C",
                            "ratingV2": "3.5",
                            "subtitle": "DINING",
                            "sideSubTitle": "Dining Ratings",
                            "bgColorV2": {
                                "type": "green",
                                "tint": "600"
                            },
                            "newOnDining": false
                        },
                        "DELIVERY": {
                            "rating_type": "DELIVERY",
                            "rating": "",
                            "reviewCount": "10",
                            "reviewTextSmall": "10 Reviews",
                            "subtext": "Not enough Delivery Reviews",
                            "color": "",
                            "ratingV2": "-",
                            "subtitle": "DELIVERY",
                            "sideSubTitle": "Delivery Ratings",
                            "bgColorV2": {
                                "type": "grey",
                                "tint": "500"
                            },
                            "newOnDelivery": false,
                            "bucketRatings": {
                                "buckets": [
                                    {
                                        "title": "Under 4 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    },
                                    {
                                        "title": "4 km to 7 km",
                                        "bgColor": {
                                            "type": "green",
                                            "tint": "500"
                                        },
                                        "rating": "3.4"
                                    },
                                    {
                                        "title": "Above 7 km",
                                        "bgColor": {
                                            "type": "grey",
                                            "tint": "500"
                                        },
                                        "rating": "0.0"
                                    }
                                ],
                                "tooltip": {
                                    "title": "For orders under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "050"
                                    },
                                    "borderColor": {
                                        "type": "grey",
                                        "tint": "300"
                                    }
                                }
                            }
                        }
                    }
                },
                "cft": {
                    "text": "₹900 for two"
                },
                "cfo": {
                    "text": "₹400 for one"
                },
                "locality": {
                    "name": "Hotel Amarpreet, Mondha, Aurangabad",
                    "address": "Amarpreet Chowk, Pandit Nehru Marg, Jalna Road, Mondha, Aurangabad",
                    "localityUrl": "aurangabad/restaurants/in/hotel-amarpreet"
                },
                "timing": {
                    "text": "",
                    "color": ""
                },
                "cuisine": [
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                        "name": "North Indian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                        "name": "Street Food"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                        "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                        "name": "Chinese"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                        "name": "Maharashtrian"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                        "name": "Desserts"
                    },
                    {
                        "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                        "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                        "name": "Beverages"
                    }
                ],
                "should_ban_ugc": false,
                "costText": {
                    "text": "₹900 for two"
                }
            },
            "order": [],
            "gold": [],
            "takeaway": [],
            "cardAction": {
                "text": "",
                "clickUrl": "/aurangabad/hotel-amarpreet-1-mondha/info",
                "clickActionDeeplink": ""
            },
            "distance": "3 km",
            "isPromoted": false,
            "promotedText": "",
            "trackingData": [
                {
                    "table_name": "zsearch_events_log",
                    "payload": "{\"search_id\":\"e5acaded-0f6f-465b-bd49-b903cd8363c5\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"dineout\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500129\",\"element_type\":\"listing\",\"rank\":68}",
                    "event_names": {
                        "tap": "{\"action\":\"tap\"}",
                        "impression": "{\"action\":\"impression\"}"
                    }
                }
            ],
            "allCTA": [],
            "promoOffer": "",
            "checkBulkOffers": false,
            "bulkOffers": [],
            "isDisabled": false,
            "bottomContainers": []
        },
        

]